import { createFileRoute } from "@tanstack/react-router"
import PhasedOutTab from "~/components/product-management/tabs/PhasedOutTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/product-management/_layout/phased-out")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Product Management Phased Out")
  return <PhasedOutTab />
}
